import { forwardRef } from "react";
import { MultiSelect } from "@etframework/ui.components";
import { useTags } from "../../data/queries/tagQueries";
import { useTranslation } from "react-i18next";

export const TagMultiSelect = forwardRef(
  ({ onSelection, initialValue, id }, ref) => {
    const { t, i18n } = useTranslation(["CreateTaskModal"]);
    const { data: tagData } = useTags();

    const init = initialValue?.map((x) => ({
      Id: tagData.find((y) => y.Title === x.Title)?.Id ?? x.Title,
      Title: x.Title,
    }));

    const fields = {
      text: "Title",
      value: "Id",
    };

    const handleOnChange = (e) => {
      onSelection?.(e.value, tagData);
    };

    return (
      <MultiSelect
        ref={ref}
        dataSource={tagData ?? []}
        fields={fields}
        label={t("TagsLabel")}
        htmlFor={id}
        id={id}
        allowCustomValues
        allowObjectBinding
        locale={i18n?.language}
        change={handleOnChange}
        value={
          init ?? null
        } /* Null (instead of undefined) avoids triggering a `useEffect` that clears the value set by using `ref.current.setValue()` Sprint5 -> Bug#112947 */
      />
    );
  }
);
